import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CUSTOMER_PROVIDER_SERVICE, ICustomerProviderService } from '../../../interfaces';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-customer-contract-items',
  templateUrl: './customer-contract-items.component.html',
  styleUrls: ['./customer-contract-items.component.css']
})
export class CustomerContractItemsComponent implements OnDestroy, OnInit {

  @Input() disabled: boolean = false;

  items$ = this.customerProviderService.customerId$.pipe(switchMap((customerId: number) => this._customerService.getCustomerContractItems(customerId)));
  sortedItems$ = combineLatest([this.items$])

  columns = [ 'itemproduct', 'itemcontractid', 'itemcount', 'itemname', 'itemcanceldate', 'controls' ];
  footerColumns = [ 'itemproduct' ];

  active: string = 'itemproduct';
  direction: SortDirection = 'asc';

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(CUSTOMER_PROVIDER_SERVICE) public customerProviderService: ICustomerProviderService,
    private _customerService: CustomerService,
    private _router: Router
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.sortData({ 'active': 'itemproduct', 'direction': 'asc' });
  }

  showContract = (contractId: number) => this._router.navigate(['/contract-details', contractId]);

  sortData(sort: Sort){
    this.direction = sort.direction;
    this.active = sort.active;
  }

}
